export const getTimezoneAbbreviation = (
  timezone: string,
  locale: string
): string => {
  const date = new Date();
  const formatter = new Intl.DateTimeFormat(locale || "en-US", {
    timeZone: timezone,
    timeZoneName: "short",
  });
  const parts = formatter.formatToParts(date);
  const timezoneAbbr = parts.find(
    (part) => part.type === "timeZoneName"
  )?.value;

  return timezoneAbbr || "Unknown";
};
